import List from "./list/attendance_list_monthly.store";

export default {
  modules: { List },
};
